import React from "react";
import { create } from "zustand";
import {
  getMedicalIncentivesData,
  getMedicalIncentivesFilterData,
} from "../api";
import { toast } from "react-toastify";

export const useMedicalIncentives = create((set) => ({
  medicalIncentivesData: {
    headers: [],
    total_row_count: 0,
    page_number: 0,
    page_size: 0,
    view_type: "",
    is_downloadable: false,
    rows_data: [],
    others: {},
  },
  medicalIncentivesLoading: false,
  medicalIncentivesError: null,
  medicalIncentivesFilterData: [],
  medicalIncentivesFilterDataLoading: false,
  medicalIncentivesFilterDataError: null,
  fetchMedicalIncentives: async (params) => {
    try {
      set({ medicalIncentivesDataLoading: true });
      const response = await getMedicalIncentivesData(params);
      set({ medicalIncentivesData: response.data });
    } catch (error) {
      set({ medicalIncentivesDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ medicalIncentivesDataLoading: false });
    }
  },
  fetchMedicalIncentivesFilter: async (params) => {
    try {
      set({ medicalIncentivesFilterDataLoading: true });
      const response = await getMedicalIncentivesFilterData(params);
      set({ medicalIncentivesFilterData: response.data });
    } catch (error) {
      set({ medicalIncentivesFilterDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ medicalIncentivesFilterDataLoading: false });
    }
  },
}));
